/**
 *
 * @module spriteThumbnailSet
 *
 */

import Check from 'check-types';

import ThumbnailSet from './thumbnailSet';

import Exception from './../exception/entry';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    number,
    nonEmptyObject
} = Check.assert;

/**
 *
 * @class SpriteThumbnailSet
 * @extends {SDK.Services.Media.ThumbnailSet}
 *
 */
export default class SpriteThumbnailSet extends ThumbnailSet {

    /**
     *
     * @param {Object} options
     * @param {Number} options.thumbnailRows
     * @param {Number} options.thumbnailColumns
     * @param {Number} options.quality
     * @note params below are checked in the base class
     * @param {Number} options.thumbnailWidth
     * @param {Number} options.thumbnailHeight
     * @param {Number} options.intervalMilliseconds
     * @param {Number} options.totalBytes
     * @param {Array<SDK.Services.Media.Presentation>} options.presentations
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: 'SpriteThumbnailSet(options)',
            get options() {
                return `${this.ctor} options should be a non-empty Object`;
            },
            get thumbnailRows() {
                return `${this.ctor} options.thumbnailRows should be a Number`;
            },
            get thumbnailColumns() {
                return `${this.ctor} options.thumbnailColumns should be a Number`;
            },
            get quality() {
                return `${this.ctor} options.quality should be a Number`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { thumbnailRows, thumbnailColumns, quality } = options;

        number(thumbnailRows, errorMessage.thumbnailRows, InvalidArgumentException);
        number(thumbnailColumns, errorMessage.thumbnailColumns, InvalidArgumentException);
        number(quality, errorMessage.quality, InvalidArgumentException);

        super(options);

        /**
         *
         * @access public
         * @type {Number}
         * @desc The number of rows of thumbnails in each sprite sheet
         *
         */
        this.thumbnailRows = thumbnailRows;

        /**
         *
         * @access public
         * @type {Number}
         * @desc The number of rows of thumbnails in each sprite sheet
         *
         */
        this.thumbnailColumns = thumbnailColumns;

        /**
         *
         * @access public
         * @type {Number}
         * @desc Quality equates to jpeg quality, which represents the loss due to compression
         *
         */
        this.quality = quality;

    }

}



// WEBPACK FOOTER //
// ./src/services/media/spriteThumbnailSet.js